import { useSelector } from 'react-redux';
const AccesRestreins = (props) => {
  const listePrivilege = useSelector(
    (state) => state.authentifie.privileges_list
  );
  if (listePrivilege !== undefined && listePrivilege.length > 0) {
    if (props.numPrivilege !== undefined) {
      return listePrivilege.indexOf(props.numPrivilege) >= 0
        ? props.children
        : null;
    } else if (props.listNumPrivilege !== undefined) {
      let ALePrivilege = false;
      for (
        let indListNumPrivilege = 0;
        indListNumPrivilege < props.listNumPrivilege.length;
        indListNumPrivilege++
      ) {
        if (
          listePrivilege.indexOf(props.listNumPrivilege[indListNumPrivilege]) >=
          0
        ) {
          ALePrivilege = true;
          break;
        }
      }
      if (ALePrivilege) {
        return props.children;
      } else {
        return null;
      }
    } else {
      return null;
    }
  } else {
    return null;
  }
};

export default AccesRestreins;
